import { Button, Form, Upload, message } from "antd";
import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import Tutorial from "../../../../components/tutorial";
const locale = require("react-redux-i18n").I18n;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function UploadBothVerify(props) {
  const { form, onChangeStep, isValidationData, onBackStep } = props;
  const [isFile, setIsFile] = useState(null);
  const [isFilePDF, setIsFilePDF] = useState(null);
  const [isFilePDFSelfie, setIsFilePDFSelfie] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [fileIndia, setFileIndia] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const fileToBase64 = (file) => {
    try {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader?.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader?.result;
          // .replace("data:", "")
          // .replace(/^.+,/, "");
          resolve(base64String);
        };
        reader.onerror = (error) => {
          reject(error);
        };
      });
    } catch (error) {
      console.log(error);
    }
  };
  const uploadOption = {
    onRemove: async (file) => {
      setIsFile(null);
      setIsFilePDF(null);
      await form.setFieldsValue({ upload: null });
      await form.validateFields(["upload"]);
    },

    beforeUpload: async (file) => {
      const isPNG = file.type === "image/png";
      const isJPG = file.type === "image/jpg";
      const isJPEG = file.type === "image/jpeg";
      const isPDF = file.type === "application/pdf";
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isPNG && !isJPG && !isJPEG && !isPDF) {
        message.error(`${file.name} is not an acceptable file type.`);
        setIsFile(null);
        await form.setFieldsValue({ upload: null });
        // await form.validateFields(["upload"]);
      } else if (!isLt2M) {
        message.error("Your file size exceeds 8MB");
      } else {
        if (isPDF) {
          setIsFilePDF(file);
          setIsFile(file);
        } else if (!file.url && !file.preview) {
          file.preview = await fileToBase64(file);
          setIsFilePDF(null);
          setIsFile(file.preview || file.url);
          // setIsFile(`data:${file.type};base64,` + file.preview || file.url);
        } else {
          setIsFilePDF(null);
          setIsFile(`data:${file.type};base64,` + file.preview || file.url);
        }
      }

      return false;
    },
  };
  const uploadIndiaOption = {
    onRemove: async (fileIndia) => {
      setFileIndia(null);

      await form.setFieldsValue({ selfie: null });
      await form.validateFields(["selfie"]);
    },
    beforeUpload: async (file) => {
      const isPNG = file.type === "image/png";
      const isJPG = file.type === "image/jpg";
      const isJPEG = file.type === "image/jpeg";
      const isPDF = file.type === "application/pdf";
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isPNG && !isJPG && !isJPEG && !isPDF) {
        message.error(`${file.name} ${locale.t("acceptedfile")}`);
        setFileIndia(null);
        await form.setFieldsValue({ selfie: null });
        // await form.validateFields(["selfie"]);
      } else if (!isLt2M) {
        message.error(locale.t("acceptedfile"));
      } else {
        if (isPDF) {
          setIsFilePDFSelfie(file);
          setFileIndia(file);
        } else if (!file.url && !file.preview) {
          file.preview = await fileToBase64(file);
          setIsFilePDFSelfie(null);
          setFileIndia(`data:${file.type};base64,` + file.preview || file.url);
        } else {
          setIsFilePDFSelfie(null);
          setFileIndia(`data:${file.type};base64,` + file.preview || file.url);
        }
      }
      return false;
    },
  };
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await fileToBase64(file);
    }
    setIsFile(file.url || file.preview);
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  useEffect(() => {
    if (form?.getFieldValue("upload")) {
      if (form.getFieldValue("upload").fileList[0]?.preview) {
        setIsFile(
          `data:${form.getFieldValue("upload").fileList[0]?.type};base64,` +
            form.getFieldValue("upload").fileList[0]?.preview
        );
      } else {
        setIsFilePDF(form.getFieldValue("upload").fileList[0]?.originFileObj);
        setIsFile(form.getFieldValue("upload").fileList[0]?.originFileObj);
      }
    }
    if (form?.getFieldValue("selfie")) {
      if (form.getFieldValue("selfie").fileList[0]?.preview) {
        setFileIndia(
          `data:${form.getFieldValue("selfie").fileList[0]?.type};base64,` +
            form.getFieldValue("selfie").fileList[0]?.preview
        );
      } else {
        setIsFilePDFSelfie(
          form.getFieldValue("selfie").fileList[0]?.originFileObj
        );
        setFileIndia(form.getFieldValue("selfie").fileList[0]?.originFileObj);
      }
    }
  }, [form]);
  return (
    <div>
      <div>
        {" "}
        <>
          <div className="d-flex justify-content-center my-5 flex-column align-items-center">
            <div className="fs-20 font-weight-300">
              {locale.t("manualtitle")}
            </div>
            <div
              className="fs-16 mt-4 text-lightgray text-center"
              style={{ maxWidth: 800 }}
            >
              {locale.t("manualsubtitle")}&nbsp;{" "}
              {locale.t(`documentType.${isValidationData.document_type}`)}{" "}
              &nbsp;
              {locale.t("manualsubtitle2")}
            </div>
            <div className="mt-5 row ">
              {[...Array(3)].map((e, i) => (
                <div key={i} className="col-4 col-md-4 px-1 px-md-4">
                  <img
                    src={`/assets/images/verify/id-doc-condition${i + 1}.png`}
                    alt={`id-doc-${i + 1}`}
                    width={"100%"}
                  />
                </div>
              ))}
            </div>
            <div className="text-center text-lightgray mt-4">
              {locale.t("acceptedfile")}
            </div>
          </div>
          <div className="px-5">
            <hr className="my-5" />
          </div>
          <div className="mb-5">
            <div className="d-flex justify-content-center align-items-center mt-5 flex-column flex-md-row">
              <Form.Item
                className="upload-verify d-flex justify-content-center"
                name="upload"
                rules={[
                  {
                    required: true,
                    // message: locale.t("dashboardFund.modalVerify.footerText3"),
                  },
                ]}
              >
                <Upload
                  {...uploadOption}
                  // fileList={false}
                  onPreview={handlePreview}
                  className="cursor-pointer "
                  showUploadList={false}
                  maxCount={1}
                >
                  {isFile ? (
                    <div
                      style={{
                        maxWidth: "270px",
                        border: "1px dashed #1CB894",
                        borderRadius: 8,
                      }}
                      className="p-4 position-reletive "
                    >
                      <div
                        className="fs-20 cursor-pointer"
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 8,
                          zIndex: 8,
                        }}
                        onClick={() => {
                          form.setFieldsValue({ upload: null });
                          setIsFile(null);
                        }}
                      >
                        x
                      </div>
                      {isFilePDF ? (
                        <Document
                          file={isFile}
                          onLoadSuccess={onDocumentLoadSuccess}
                        >
                          <Page
                            width={200}
                            pageIndex={0}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                          />
                        </Document>
                      ) : (
                        <img
                          src={isFile}
                          alt="eieiei"
                          width={"100%"}
                          style={{ borderRadius: 8 }}
                        />
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        maxWidth: "270px",
                        border: "1px dashed #1CB894",
                        borderRadius: 8,
                        width: 268,
                        height: 138,
                      }}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <div
                        className="text-center position-absolute "
                        style={{ top: 8 }}
                      >
                        {locale.t("fontcard")}
                      </div>
                      <div
                        style={{
                          borderRadius: "50%",
                          background: "rgba(29, 163, 130, 0.20)",
                          fontSize: 32,
                          width: 56,
                          height: 56,
                        }}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.3334 14.6667H29.3334V17.3334H17.3334V29.3334H14.6667V17.3334H2.66669V14.6667H14.6667V2.66675H17.3334V14.6667Z"
                            fill="#1DA382"
                          />
                        </svg>
                      </div>
                    </div>
                  )}
                </Upload>
              </Form.Item>
              <div className="mx-2" />
              <Form.Item
                className="upload-verify"
                name="selfie"
                rules={[
                  {
                    required: true,
                    // message: locale.t("dashboardFund.modalVerify.footerText3"),
                  },
                ]}
              >
                <Upload
                  className="cursor-pointer"
                  // className="iux-scan-id"
                  // fileList={false}
                  {...uploadIndiaOption}
                  //   fileList={file}
                  showUploadList={false}
                  maxCount={1}
                >
                  {fileIndia ? (
                    <div
                      style={{
                        maxWidth: "270px",
                        border: "1px dashed #1CB894",
                        borderRadius: 8,
                      }}
                      className="p-4 position-reletive"
                    >
                      <div
                        className="fs-20 cursor-pointer"
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 8,
                          zIndex: 8,
                        }}
                        onClick={() => {
                          form.setFieldsValue({ selfie: null });
                          setFileIndia(null);
                        }}
                      >
                        x
                      </div>
                      {isFilePDFSelfie ? (
                        <Document
                          file={fileIndia}
                          onLoadSuccess={onDocumentLoadSuccess}
                        >
                          <Page
                            width={200}
                            pageIndex={0}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                          />
                        </Document>
                      ) : (
                        <img
                          src={fileIndia}
                          alt="file"
                          width={"100%"}
                          style={{ borderRadius: 8 }}
                        />
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        maxWidth: "270px",
                        border: "1px dashed #1CB894",
                        borderRadius: 8,
                        width: 268,
                        height: 138,
                      }}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <div
                        className="text-center position-absolute "
                        style={{ top: 8 }}
                      >
                        {locale.t("backcard")}
                      </div>
                      <div
                        style={{
                          borderRadius: "50%",
                          background: "rgba(29, 163, 130, 0.20)",
                          fontSize: 32,
                          width: 56,
                          height: 56,
                        }}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.3334 14.6667H29.3334V17.3334H17.3334V29.3334H14.6667V17.3334H2.66669V14.6667H14.6667V2.66675H17.3334V14.6667Z"
                            fill="#1DA382"
                          />
                        </svg>
                      </div>
                    </div>
                  )}
                </Upload>
              </Form.Item>
            </div>
            <div className="text-center mt-3">{locale.t("uploadfile")}</div>

            <div
              className="text-center mt-3 text-lightdark mx-auto"
              style={{ maxWidth: 800 }}
            >
              {locale.t("anotherdeviceDetail")}
            </div>
            <div className="text-center mt-3 text-primary-sub-iux cursor-pointer">
              <Tutorial isButton />
            </div>
          </div>
          <Form.Item shouldUpdate>
            {() => (
              <div className="text-center">
                <Button
                  disabled={
                    form.getFieldValue("upload") === undefined ||
                    form.getFieldValue("upload") === null ||
                    isFile === null ||
                    form.getFieldValue("selfie") === undefined ||
                    form.getFieldValue("selfie") === null ||
                    fileIndia === null
                  }
                  // type="submit"
                  // loading={loading}
                  onClick={() => onChangeStep("upload")}
                  className="btn-primary-new-iux"
                >
                  {locale.t("continue")}
                </Button>
              </div>
            )}
          </Form.Item>
          <div
            className="text-center mt-3 text-primary-sub-iux cursor-pointer"
            onClick={() => onBackStep(1)}
          >
            {locale.t("back")}
          </div>
        </>
      </div>
    </div>
  );
}

export default UploadBothVerify;
